import React from "react";
import {Field, FieldArray, reduxForm} from "redux-form/immutable";
import {Map} from "immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

function renderLines(fieldProps) {
  const {fields, products} = fieldProps;
  return (
    <React.Fragment>
      {fields.map((member, index) => (
        <React.Fragment key={index}>
          <tr className="lineSeparator">
            <th>Line {index + 1}</th>
            <td>
              <ActionButton label="Remove line" primary={false} onClick={() => fields.remove(index)} />
            </td>
          </tr>
          <Field
            label="Product"
            name={`${member}.sku`}
            component={DropDownInputField}
            data={products}
            valueKey="sku"
            titleKey="sku"
            showBlank={true}
            />
          <Field
            label="Quantity"
            name={`${member}.quantity`}
            type="number"
            normalize={numerical}
            component={TextInputField}
            />
        </React.Fragment>
      ))}
      <tr>
        <td colSpan={2}>
          <ActionButton label="Add line without serials" primary={false} onClick={() => fields.push(Map())} />
        </td>
      </tr>
    </React.Fragment>
  )
}

class AddManualPalletForm extends React.Component {

  render() {
    let {errors, handleSubmit, submit, products, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Add Manual Pallet";
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field
              label="Pallet Id"
              name="palletId"
              component={TextInputField}
              serverError={this.props.errors.palletId}
              />
            <Field
              label="Serial Numbers"
              name="serialNrs"
              component={TextAreaInputField}
              rows={8}
              serverError={this.props.errors.serialNrs}
              />
            <tr>
              <td colSpan={2} className="help">
                Scan or paste the serial numbers of the water on this pallet, one per line or separated by commas.
                Write a run of consecutive serials as FIRST..LAST. Each serial counts as one unit of its own SKU.
              </td>
            </tr>
            <FieldArray name="lines" component={renderLines} props={{products}} />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddManualPalletToTransferForm"
})(AddManualPalletForm);

export default ReduxForm;
